import * as React from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

export default function Features() {
  const styles = {
    AboutText: {
      padding: '60px 0',
      borderTop: '1px solid var(--border)',
      borderBottom: '1px solid var(--border)',
      overflow: 'hidden',
      background: 'var(--bg - dark)',
    },

    textGradient: {
      background: 'linear-gradient(135deg, #ffffff, #A5E13B)', // Substituí var(--primary) pela sua cor verde
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text',
      fontWeight: 'inherit', // Para manter o peso do h2,
      lineHeight: 1.2,
      fontWeight: 700,
      fontSize: '3rem',
      marginBottom: '24px',
      letterSpacing: '-1px', // O valor negativo deve ser uma string '-1px'
      lineHeight: 1.2,
    },

    TextStyle: {
      color: '#9FA4B4',
      marginBottom: '16px',
      fontSize: '1.05rem',
    },

    btn: {
      alignItems: 'center',
      justifyContent: 'center',
      gap: '10px',
      padding: '30px 30px',
      borderRadius: '50px',
      fontFamily: 'var(--font - headings)',
      fontWeight: '600',
      fontSize: '0.95rem',
      cursor: 'pointer',
      border: 'none',
      whiteSpace: 'nowrap',
      letterSpacing: '0.5px',
      textTransform: 'uppercase',
      transition: 'all var(--transition-smooth)',
    },

    btnOutline: {
      background: 'transparent',
      color: 'var(--text-light)',
      border: '1px solid #ffffff66',
    },
  }

  return (
    <Container id="AboutUS" sx={styles.AboutText}>
      <Typography style={styles.textGradient}>
        Quem somos
      </Typography>
      <p style={styles.TextStyle}>Bem-vindo à Phorm Pass, a plataforma que conecta pessoas e empresas a uma vasta rede de academias, Box de Cross Training, salas de pilates, profissionais da saúde e muito mais. Nossa missão é proporcionar uma experiência integrada, priorizando saúde e bem-estar para todos.</p>
      {'\n'}
      <p style={styles.TextStyle}>Fundada por especialistas em TI e comunicação, desenvolvemos um ecossistema focado na usabilidade, democratizando o acesso a espaços de treinamento de excelência com mensalidades verdadeiramente atrativas. </p>
      {'\n'}
      <p style={styles.TextStyle}>Sua jornada fitness deve ser simples. Junte-se à nós e faça parte da revolução fitness no Brasil. Phorm – Saúde para todos.</p>
      <br />

      <Button sx={[styles.btn, styles.btnOutline,]} href="https://wa.me/55015988383050" >
        Fale Conosco
      </Button>
    </Container >
  );
}
